/**
* In this file contains the Diagnosis View popup UI screen and logic
**/
import { Modal,Button } from 'react-bootstrap';
import { useState,useEffect } from 'react';
import ApiService from './../../services/ApiService';
import MessageModal from './../../shared/modals/MessageModal';
import PrescriptionViewModal from './PrescriptionViewModal'; // Import the new prescription modal
import Pagination from './../../shared/components/Pagination';
import { convertUTCtoLocal } from './../../services/UtilsService';
import { useTranslation } from 'react-i18next';

function DiagnosisViewModal(props) {
	/**
	 * Intial state declaration
	 **/
	const [data,setData]=useState([]);
	const [count,setCount]=useState(0);
	const [request,setRequest]=useState({page:0,limit:10,id:props.data.id});
	const [modal,setModal]=useState({});
	const [prescriptionModal, setPrescriptionModal] = useState({ showPrescription: false, prescription_items: [], diagnosis: '', name: '' }); // Add prescription modal state
	const [isLoading, setIsLoading] = useState(true);
	const role = Number(localStorage.getItem('role'));
	const { t } = useTranslation();

	//Component initialize function
	useEffect(()=>{
		const fetchData = async () => {
			setIsLoading(true); 
			try {
			  var response = await ApiService.getMemberDiagnosis(request);
				if(response.status===200){
				   await setData(response.data.diagnoses);
				   await setCount(response.data.count);
				}
			}catch (error) {
				console.error('Error fetching member diagnosis:', error);
			} finally {
				setIsLoading(false); 
			}
		};
		fetchData();	
	},[request]);
	
	/**
	* To handle pagination event
	* @data we get the user selected page Number
	**/
	  const handlePaginate=(data)=>{  
		  setRequest(req=>({...req,page:data}));
	  };
	  
	  //To close modal
	  const handleClose=()=>setModal({});

	// To handle View Prescription click
	const ViewPrescription = (item) => {
	setPrescriptionModal({
		showPrescription: true,
		prescription_items: item.prescription_items || [],
		diagnosis: item.diagnosis,
		name: props.data?.name,
		dob: props.data?.dob
	});
	};

	// To close prescription modal
	const handlePrescriptionClose = () => {
	setPrescriptionModal({ showPrescription: false, prescription_items: [], diagnosis: '', name: '' });
	};
	
  return (
	<>
  <Modal 
	show={props.data.viewDiagnosis} 
	onHide={props.handleClose}  
	backdrop="static"
    keyboard={false}
	size="xl"
    aria-labelledby="contained-modal-title-vcenter"
    centered
  >
  {/*import MessageModal*/}
  {Object.keys(modal).length !==0 && <MessageModal data={modal} handleClose={handleClose} />}
  
      <Modal.Header closeButton className={`${role===4?'admin-modal-header':''}`}>
        <Modal.Title><h5 className="modal-title text-capitalize" id="ViewDiagnosisModal">{props.data?.name}{t('common.possessive_suffix')} {t('modal.viewDiagnosis')}</h5></Modal.Title>
      </Modal.Header>
      <Modal.Body>
	  <div className="row">
		<div className="col-xxl-12 mb-5">
			<div className="table-responsive">	
			{/*DiagnosisView List Table*/}
			<table className="table table-borderless theme-table">
				<thead className="table-nowrap">
				  <tr>
				    <th>{t('table.createdDate')}</th>
					<th>{t('modal.diagnosis')}</th>
					<th>{t('modal.recordedDate')}</th>
					<th className="text-center">{t('table.notes')}</th>
					<th>{t('modal.treatment')}</th>
					{/*<th>{t('table.medication')}</th>*/}
					<th>{t('modal.followup')}</th>
					{/* <th>{t('modal.ViewPrescription')}</th> */}
				  </tr>
				</thead>
				<tbody>
				{data && data.length !==0 && data.map((item,i)=>(<tr key={i} className="text-capitalize">										
						<td>{convertUTCtoLocal(new Date(item.createdAt).toUTCString())}</td>
						<td className="text-capitalize">{item.diagnosis}</td>
						<td>{convertUTCtoLocal(new Date(item.recorded_date).toUTCString())}</td>
						<td className="text-center">
							<span onClick={()=>setModal({show:true,message:item.notes,title: t('table.notes')})}>
							  <i className={`fa-solid fa-file-lines ${role === 4 ? 'admin-table-link text-tmAquaDgreen' : 'text-primary'}`} />
							</span>
						</td>
						<td className="text-capitalize">{item.treatment}</td>
						{/*<td className="text-capitalize">{item.medication}</td>*/}
						<td>{item.follow_up===true ? convertUTCtoLocal(new Date(item.follow_up_date).toUTCString()):'--'}</td>
						{/* <td className="text-center">
								<span onClick={() => ViewPrescription(item)} style={{ cursor: 'pointer' }}>
							  <i className={`fa-solid fa-file-lines ${role === 4 ? 'admin-table-link text-tmAquaDgreen' : 'text-primary'}`} />
							</span>
						</td> */}
					</tr>))}
					{data.length ===0 && !isLoading && <tr>
					<td colSpan="11" className="text-center text-capitalize">{t('common.noRecord')}</td>
					</tr> }
				</tbody>
			</table>
			{/*End DiagnosisView List Table*/}
		</div>	
		</div>
	</div>
	{/*Pagination*/}
	  <div className="row my-3">
		<div className="col-xxl-12 d-flex justify-content-center">
			{data.length !==0 && <Pagination page={request.page} handlePaginate={handlePaginate} total={count}  />}
			</div>
	  </div>
	  {/*End Pagination*/}
	</Modal.Body>
	{/*Footer*/}
	  <Modal.Footer>
	   <Button variant="secondary" className={`btn btn-sm ${role === 4 ? 'btn-tmAquaGreen' : 'btn-tmBlue'}`} onClick={props.handleClose}>
	   	  {t('modal.close')}
        </Button>
	  </Modal.Footer>
	  {/*End Footer*/}
	</Modal>
	{/* Prescription View Modal */}
	<PrescriptionViewModal 
		data={prescriptionModal} 
		handleClose={handlePrescriptionClose} 
	/>
	</>
  );
}

export default DiagnosisViewModal;
